
import React, { useEffect, useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import { getLanguagesWithPagination, deleteLanguage } from "adminApi/LanguageApi/Language";
import DataTable from "Common/DataTable/DataTable";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import fields from "../../json/LanguageFields.json";

const LanguageListTable = ({ Language }) => {
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebouncedValue(search, 500);
  const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
  const sizeOptions = [10, 20, 50, 100];
  const { tabledata } = fields

  // Fetch Hook
  const { data, meta, loading, error, refetch } = usePaginatedFetch(getLanguagesWithPagination, {
    page,
    limit,
    search: debouncedSearch,
    title: "Language List",
  });


  useEffect(() => {
    refetch();
  }, [Language]);


  // Auto-generate display fields 
  const displayFields = generateDisplayFields(tabledata);



  // Table Hook
  const { formattedData, columns } = useTableConfig({
    data,
    page,
    limit,
    canShowAction,
    refetch,
    config: {
      entityName: "Language",
      editUrl: "language-edit",
      idKey: "COLUMN_NAME",
      deleteApi: deleteLanguage,
      displayFields,
    },
  });

  const handleSearch = (val, resetPage = null) => {
    setSearch(val);
    if (resetPage !== null) setPage(resetPage);
  };

  const onPageChange = (p) => { setPage(p) };

  const onLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
  };


  return (
    <DataTable
      columns={columns}
      data={formattedData}
      options={{
        loading,
        error,
        sortableColumns: displayFields.map((f) => f.accessor),
        copy: true,
        csv: true,
        pdf: true,
        print: true,
        fileName: "Language List",
      }}
      Search={{
        search: true,
        SearchInputValue: search,
        handleSearch: handleSearch,
      }}
      Entries={{
        Entries: true,
        limit,
        onLimitChange,
        options: sizeOptions,
      }}
      pagination={{
        isActive: true,
        meta,
        onPageChange,
      }}
    />
  );
};

export default LanguageListTable;
